import { initializeApp, getApps, FirebaseApp } from "firebase/app";
import { Auth, getAuth } from "firebase/auth";
import { Firestore, getFirestore } from "firebase/firestore";
import { Functions, getFunctions } from "firebase/functions";

const dineCentralConfig = {
  apiKey: process.env.REACT_APP_DINECENTRAL_API_KEY!,
  authDomain: process.env.REACT_APP_DINECENTRAL_AUTH_DOMAIN!,
  projectId: process.env.REACT_APP_DINECENTRAL_PROJECT_ID!,
  storageBucket: process.env.REACT_APP_DINECENTRAL_STORAGE_BUCKET!,
  messagingSenderId: process.env.REACT_APP_DINECENTRAL_MESSAGING_SENDER_ID!,
  appId: process.env.REACT_APP_DINECENTRAL_APP_ID!,
  measurementId: process.env.REACT_APP_DINECENTRAL_MEASUREMENT_ID,
};

const getDineCentralApp = (): FirebaseApp => {
  const existing = getApps().find((a) => a.name === "dinecentral");
  return existing ?? initializeApp(dineCentralConfig, "dinecentral");
};

const app = getDineCentralApp();

export const DINECENTRAL_AUTH: Auth = getAuth(app);
export const DINECENTRAL_FIRESTORE: Firestore = getFirestore(app); // single default database
export const DINECENTRAL_FUNCTIONS: Functions = getFunctions(app, process.env.REACT_APP_DINECENTRAL_FUNCTIONS_REGION);